import {useState} from 'react';
import React, {Component} from 'react';
import Input from './input-with-label';
import Checkbox from './checkbox';
import NavLink from '../react/nav-link';

import SeamApi from '../../lib/seam-api';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import {DateRangePicker, SingleDatePicker, DayPickerRangeController} from 'react-dates';


const fields  = ['first_name', 'last_name', 'email'];


const checkboxes = [
    {
        text: 'Please add me to DMC’s Mailing List',
        id: 1
    }
];

class Arrange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accept: false,
            acceptError : false,
            dateError : false,
            permissions: {},
            errors : {},
            success:  false,
            startDate: null,
            endDate: null,
            focusedInput: false,
        };
    }

    handleChange(e) {
        this.setState({
            errors:  {},
            [e.target.name] : e.target.value,
        });
    }

    handleErrors(data) {
        this.setState({errors : data});
    }

    formatParams() {
        let params = {
            source_distribution_id : 1,
            subject: 'Arrange a visit',
            message: 'Arrange a visit',
            contact_permissions : [],
            meta : {
                company_name : this.state.company_name,
                start_date: this.state.startDate,
                end_date: this.state.endDate,
            }
        };

        fields.forEach((field) => {
           if(this.state.hasOwnProperty(field)) {
               if(this.state[field].length >= 1) {
                   params[field] = this.state[field];
               }
           }
        });


         _.each(this.state.permissions, (i, index) => {
             if(i === true) {
                 params.contact_permissions.push(parseInt(index));
             }
        });


        return params;

    }

    isDayBlocked(day) {
        const days = [0, 6]
        return days.includes(day.day());
    }

    renderDay(day) {
        let classes = ' ';

        if(day.modifiers) {
            classes += Array.from(day.modifiers).map(m => `CalendarDay__${m}`).join(' ');
        }

        return (
            <td
                className={classes}
                role="button" aria-disabled="true"
                onClick={() => day.onDayClick(day.day)}
                style={{width: '39px', height: '38px'}}>
                <div className={day.day ? 'CalendarDay__inner' : ''}>{day.day ? day.day.date() : ''}</div>
            </td>
        );
    }

    handleSubmit() {


        this.setState({ dateError: false });

        if(this.state.accept === false) {
            return this.setState({ acceptError : true });
        }

        this.setState({ acceptError : false });

        SeamApi.contacts().message(this.formatParams(), this.handleErrors.bind(this)).then(() => {

            let params = { success : true };

            fields.forEach(field => {
                params[field] = '';
            });

            this.setState(params);
        });
    }

    getErrors(name) {
        return this.state.errors.hasOwnProperty(name) ? this.state.errors[name]  : [];
    }

    render() {
        return (
            <div className="overlay-arrange">
                <h1>ARRANGE A VISIT</h1>
                <form>
                    <div className="overlay__content">
                        <div className="overlay-arrange__left">
                            <div className="overlay-arrange__left-column">
                                <p className="arrange-left__column-title">When would be suitable to arrange a visit?</p>
                                <DateRangePicker
                                    renderCalendarDay={this.renderDay.bind(this)}
                                    numberOfMonths={1}
                                    startDatePlaceholderText="Start Date"
                                    endDatePlaceholderText="End Date"
                                    noBorder='true'
                                    startDateId="startDate"
                                    endDateId="endDate"
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    onDatesChange={({startDate, endDate}) => {
                                        this.setState({ startDate, endDate })
                                    }}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                                    transitionDuration={0}
                                    hideKeyboardShortcutsPanel={true}
                                    enableOutsideDays={false}
                                    firstDayOfWeek={0}
                                    isDayBlocked={this.isDayBlocked.bind(this)}
                                />
                            </div>
                            <div className="overlay-arrange__left-column">
                                <p className="arrange-left__column-title">What happens next?</p>
                                <p>Your request will be sent to our experience team and we will contact you to confirm your
                                    visit along with time slot availability.</p>
                            </div>
                            <div className="overlay-arrange__left-column">
                                <a href="#" onClick={() => this.props.setSelectedTab(0)}>Prefer to speak to us?</a>
                            </div>
                        </div>
                        <div className="overlay-arrange__right">
                            <Input name="first_name" value={this.state.first_name} placeholder="Your First Name" onChange={this.handleChange.bind(this)}  errors={this.getErrors('first_name')}/>
                            <Input name="last_name" value={this.state.last_name} placeholder="Your Last Name" onChange={this.handleChange.bind(this)}  errors={this.getErrors('last_name')}/>
                            <Input name="email" value={this.state.email} placeholder="Your Email Address" onChange={this.handleChange.bind(this)} errors={this.getErrors('email')}/>
                            <Input name="company_name" value={this.state.company_name} placeholder="Your Business Name" onChange={this.handleChange.bind(this)} />

                            <div className="overlay__bottom overlay-arrange__bottom">
                                <div className='overlay-section__checkboxes'>
                                    <div className="checkbox__outer">
                                        <Checkbox
                                            ariaLabelledby="label__privacy"
                                            checked={this.state.accept}
                                            square={true}
                                            toggleCheckBox={() => this.setState({ accept : !this.state.accept, acceptError: false, success: false })}/>
                                        <p id="label__privacy">I Accept the <a target={'_blank'} rel={'noreferrer'} href="https://www.barnsley.gov.uk/services/information-and-privacy/your-privacy/">privacy policy</a></p>
                                    </div>

                                    { checkboxes.map(({text, id}, index) => {
                                        return (
                                            <div key={id} className="checkbox__outer">
                                                <Checkbox
                                                    ariaLabelledby="label__mail"
                                                    checked={this.state.permissions.hasOwnProperty(id) && this.state.permissions[id] === true}
                                                    square={true}
                                                    toggleCheckBox={() => this.setState({
                                                        permissions: Object.assign({}, this.state.permissions, {
                                                            [id]: !this.state.permissions[id]
                                                        })
                                                    })} />
                                                <p id="label_mail" >{text}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                                { !this.state.success && <div className="overlay__send">
                                    <NavLink text="BOOK" color="green" onClick={this.handleSubmit.bind(this)}/>
                                </div> }
                            </div>

                            { this.state.acceptError && <div className="message input-outer__errors"><p>Please accept our privacy policy</p></div> }
                            {/*{ this.state.dateError && <div className="message input-outer__errors"><p>Please select a start and end date</p></div> }*/}
                            { this.state.success && !this.state.acceptError && <div className="overlay-speak__success">
                                Thank you for contacting us! Your enquiry will be seen to by our experience team and responded to shortly.
                            </div> }
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default Arrange;
